export interface Volume {
  icon: string
  number: string
  title: string
  subtitle: string
  problem: string
  bullets: string[]
  result: string
  popular?: boolean
}

export const volumes: Volume[] = [
  {
    icon: '📗',
    number: 'Volume 1 — Ninja Foundations & Movement Skills — 25 classes',
    title: 'Ninja Foundations & Movement Skills',
    subtitle: 'The foundation your athletes need to feel safe and supported from day one',
    popular: true,
    problem:
      'Training beginners is one of the most rewarding — and most demanding — parts of being a Ninja coach. This volume gives you everything you need to guide new athletes with clarity, patience, and structure, without improvising a single progression.',
    bullets: [
      'How to introduce fundamental movement patterns logically and accessibly',
      'How to guide athletes who have never trained Ninja before',
      'How to create a safe and supportive environment through clear language and structured progressions',
      'Modifications, regression options, and safer alternatives built into every class',
      'How to build coordination, body control, and spatial awareness from scratch',
    ],
    result: 'Your beginners feel supported, capable, and motivated to come back — from their first day.',
  },
  {
    icon: '📘',
    number: 'Volume 2 — Grip, Hanging & Upper-Body Skills — 25 classes',
    title: 'Grip, Hanging & Upper-Body Skills',
    subtitle: 'Strength, control, and upper-body efficiency — completely structured',
    problem:
      'Grip and hanging work is one of the pillars of Ninja. This volume gives you 25 completely structured sessions with progressions from basic grip to advanced brachiation, so every class feels intentional and builds real strength.',
    bullets: [
      'How to build grip strength safely and progressively',
      'How to guide athletes from dead hang to active hang with total control',
      'How to teach brachiation with clear rhythm and coordination',
      'How to integrate grip transitions and apprehension changes safely',
      'Coaching technique, cues, and corrections written and ready for every station',
    ],
    result:
      'You teach grip and hanging with confidence and consistency — and your athletes develop real strength with flawless technique.',
  },
  {
    icon: '📙',
    number: 'Volume 3 — Balance, Agility & Footwork — 25 classes',
    title: 'Balance, Agility & Footwork',
    subtitle: 'Precision, speed, and control — completely guided',
    problem:
      'Balance and agility are what separate good athletes from excellent athletes. This volume removes the planning burden completely and gives you 25 sessions that flow beautifully from the first moment.',
    bullets: [
      'How to build balance progressively — from static to dynamic to reactive',
      'How to teach foot placement precision without it feeling repetitive',
      'How to develop agility and directional changes with clear structure',
      'How to maintain energy and awareness without rushing or losing momentum',
      "Complete timing so you're never short or running over",
    ],
    result:
      'Your athletes develop real control — and your classes feel professional, varied, and progressive.',
  },
  {
    icon: '📕',
    number: 'Volume 4 — Obstacle Technique & Skill Progressions — 30 classes',
    title: 'Obstacle Technique & Skill Progressions',
    subtitle: 'Technique, progressions, and corrections — everything you need to teach any obstacle',
    problem:
      'Most coaches teach obstacles intuitively. This volume gives you the structured foundation — every obstacle broken down, every progression clear, every common error with its specific correction.',
    bullets: [
      'How to teach wall, warped wall, monkey bars, rings, lache, and more — step by step',
      'How to structure technique sessions that build mastery without frustration',
      'How to identify errors quickly and correct with clear cues',
      'Modifications for athletes at every experience level',
      'Progressions from fundamental movements to advanced execution',
    ],
    result:
      "Your athletes progress quickly — because they're learning with structure, not trial and error.",
  },
  {
    icon: '📓',
    number: 'Volume 5 — Course Flow, Speed & Endurance — 30 classes',
    title: 'Course Flow, Speed & Endurance',
    subtitle: 'Connect skills, optimize efficiency, train for real performance',
    problem:
      'Course flow is where true progress is revealed. This volume gives you 30 completely designed sessions to teach transitions, pacing, speed, and endurance — all integrated.',
    bullets: [
      'How to structure sessions that connect multiple obstacles smoothly',
      'How to train speed without sacrificing technique',
      'How to develop Ninja-specific endurance',
      'How to teach course strategy and decision-making',
      'Mini-courses, challenges, and simulations ready to use',
    ],
    result:
      'Your athletes don’t just master individual obstacles — they flow through complete sequences with control, speed, and confidence.',
  },
  {
    icon: '📔',
    number: 'Volume 6 — Advanced Coaching, Competition & Athlete Development — 15 classes',
    title: 'Advanced Coaching, Competition & Athlete Development',
    subtitle: 'Train serious athletes, prepare for competition, long-term development',
    problem:
      'When your athletes are ready for the next level, you need different structure. This volume gives you tools for advanced coaching, competition preparation, assessment, and holistic athlete development.',
    bullets: [
      'How to structure high-performance sessions',
      'How to prepare athletes for competition without creating anxiety',
      'How to use assessment and progress tracking effectively',
      'How to create long-term development plans',
      'Challenge sessions, competition simulations, and skill testing',
    ],
    result:
      'Your serious athletes get the coaching they need to reach their potential — and you have the structure to guide them there.',
  },
]
